import moment from 'moment'

export function normalizeMoney (value) {
  if (value === null || value === undefined || value === '') return 0
  if (typeof value === 'number') return value

  const rawValue = String(value).replace(/[^0-9,.-]/g, '')
  if (!rawValue) return 0

  const normalized = rawValue.indexOf(',') !== -1
    ? rawValue.replace(/\./g, '').replace(',', '.')
    : rawValue

  const parsed = parseFloat(normalized)
  return isNaN(parsed) ? 0 : parsed
}

export function formatBRLCurrency (value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(normalizeMoney(value))
}

export function formatBRDate (value) {
  if (!value) return '--'

  // Keep calendar day stable for API date/datetime strings and avoid TZ shifts.
  if (typeof value === 'string') {
    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (match) return `${match[3]}/${match[2]}/${match[1]}`
  }

  const parsed = moment(value, [moment.ISO_8601, 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY'], true)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '--'
}



// WEBPACK FOOTER //
// ./src/utils/formatters.js